import { render, staticRenderFns } from "./ReadDocumentList.vue?vue&type=template&id=fc484c14"
import script from "./ReadDocumentList.js?vue&type=script&lang=js&external"
export * from "./ReadDocumentList.js?vue&type=script&lang=js&external"
import style0 from "./ReadDocumentList.vue?vue&type=style&index=0&id=fc484c14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports